import { render, staticRenderFns } from "./FunkButton.vue?vue&type=template&id=6e60ffda&scoped=true"
import script from "./FunkButton.vue?vue&type=script&lang=js"
export * from "./FunkButton.vue?vue&type=script&lang=js"
import style0 from "./FunkButton.vue?vue&type=style&index=0&id=6e60ffda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e60ffda",
  null
  
)

export default component.exports